// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1b7pC","label":"Radio_label__OT44Q","checkMark":"Radio_checkMark__t6bY2","disabled":"Radio_disabled__3Vd5W"};